<template>
  <div class="home">
    <Header :linkData="this.linkCall()" />
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <img class="not_visible_meta" alt src="img/space3_facebook.png" />
    <div class="hero">
      <div class="copy">
        <h1 class="copy__title">
          <!-- Crea tu tienda online y comience a vender ! -->
          {{ $t('home.heroWelcome') }}
          <!-- {{ $vuetify.t('welcomeMsg') }} -->
        </h1>
        <p class="copy__desc" v-html="$t('home.heroDesc')">{{}}</p>
        <div class="copy__btn">
          <!-- <v-btn text>
            Crear mi tienda ya!
            <span class="icone material-icons">keyboard_return</span>
          </v-btn>-->

          <v-btn
            class="pry-btn"
            href="https://forms.gle/edB2WoMCptYCe2rGA"
            target="_blank"
            text
          >
            Registrarse para la beta!
            <span class="icone material-icons">keyboard_return</span>
          </v-btn>
          <!-- <v-btn class="pry-btn">Comenzar</v-btn> -->
        </div>
      </div>
      <div class="copy video">
        <div class="responsive-embed">
          <v-img
            aspect-ratio="1.2"
            max-width="100%"
            class="hero__img"
            src="../assets/img/fondo_03.jpg"
          />
          <!-- <img class="hero__right" alt src="../assets/img/fondo_03.jpg" /> -->
          <!-- <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/RGJp18IGac4"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe> -->
        </div>
      </div>
    </div>
    <div class="bna_site">
      <div class="bg_site_forme"></div>
      <!-- <div class="bna__ctn-img">
        <img alt src="../assets/img/slide_1.jpg" />
      </div>
      <div class="bna__ctn-img">
        <img alt src="../assets/img/slide_2.jpg" />
      </div>
      <div class="bna__ctn-img">
        <img alt src="../assets/img/slide_3.jpg" />
      </div>
      <div class="bna__ctn-img">
        <img alt src="../assets/img/slide_1.jpg" />
      </div>-->
    </div>

    <v-container>
      <section class="st_sone ini">
        <v-row no-gutters>
          <v-col cols="12" md="6" sm="6">
            <div class="copy__imgsone">
              <v-img
                aspect-ratio="1.2"
                max-width="100%"
                class="img-home"
                contain
                src="../assets/img/ban_2.png"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <div class="copy__sone">
              <div class="center__sone">
                <p class="title__sone">Cree su tienda Online</p>
                <p class="desc__sone">
                  Escriba el nombre para su negocio o emprendimiento, cargue sus
                  productos y potencie su marca con nuestra guía.
                </p>
                <v-btn
                  class="text-btn"
                  text
                  href="https://medium.com/lubumas/5-pasos-para-construir-su-marca-en-el-2020-7015e5131fc6"
                  target="_blank"
                >
                  Explorar guia de Marca
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </section>
      <section class="st_sone order">
        <v-row no-gutters>
          <v-col class="order-col" cols="12" md="6" sm="6">
            <div class="copy__sone">
              <div class="center__sone">
                <p class="title__sone">Inicie a vender por internet</p>
                <p class="desc__sone">
                  Comparta su tienda en sus redes sociales o simplemente
                  cuéntele a sus amigos sobre su nuevo negocio o emprendimiento
                  y preparate para el boom de su negocio.
                </p>
                <v-btn class="text-btn" text>
                  Consejos para su primer venta
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col class="order-col" cols="12" md="6" sm="6">
            <div class="copy__imgsone">
              <v-img
                aspect-ratio="1.2"
                max-width="100%"
                class="img-home"
                contain
                src="../assets/img/ban_1.png"
              />
              <!-- <v-img aspect-ratio="1" contain src="../assets/img/c79.jpg" /> -->
            </div>
          </v-col>
        </v-row>
      </section>
      <section class="st_sone fin">
        <v-row no-gutters>
          <v-col cols="12" md="6" sm="6">
            <div class="copy__imgsone">
              <v-img
                aspect-ratio="1.2"
                max-width="100%"
                class="img-home"
                contain
                src="../assets/img/office.jpg"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <div class="copy__sone">
              <div class="center__sone">
                <p class="title__sone">Control a un solo clic</p>
                <p class="desc__sone">
                  Todo el control que pueda necesitar su negocio desde gestionar
                  pedidos, envíos, pagos, desde la comodidad de un café en su
                  tienda favorita.
                </p>
                <v-btn class="text-btn" to="/help" text>
                  Panel de Ayuda
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </section>
      <section class="st_sone">
        <v-row no-gutters>
          <v-col cols="12" md="12" sm="12">
            <div class="st__testimonial">
              <div class="box__img">
                <v-img
                  aspect-ratio="1"
                  height="400px"
                  src="../assets/img/mural_office.jpg"
                />
              </div>
              <div class="box__copy">
                <p class="title__st">
                  Somos un equipo interdiciplinario que queremos brindarle la
                  mejor asistencia en el camino a la transformación digital de
                  su negocio.
                </p>
                <p class="sub__st">CEO | Diego Achury</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </section>
    </v-container>

    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue';
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',

  components: {
    //HelloWorld,
    Header,
    Footer,
  },

  methods: {
    linkCall() {
      return 'home_isActive'
    },
  },
  created() {
    this.linkCall()
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Lubumas',
    // all titles will be injected into this template
    titleTemplate: '%s | Plataforma de eCommerce',
    meta: [
      { charset: 'utf-8' },
      {
        property: 'og:image',
        content: 'https://lubumas.com/img/space3_facebook.png',
      },
      { property: 'og:type', content: 'website' },
      {
        property: 'og:url',
        content: 'https://lubumas.com/',
      },
      {
        property: 'og:title',
        content: 'Lubumas - Plataforma de eCommerce',
      },
      {
        property: 'og:description',
        content:
          'Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio.',
      },

      { property: 'og:site_name', content: 'lubumas' },
      // Twitter card
      { name: 'twitter:card', content: 'summary' },
      {
        name: 'twitter:site',
        content: 'https://lubumas.com/',
      },
      { name: 'twitter:title', content: 'Lubumas | Plataforma de eCommerce' },
      {
        name: 'twitter:description',
        content:
          'Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio',
      },
      // Your twitter handle, if you have one.
      { name: 'twitter:creator', content: '@diegoachury' },
      {
        name: 'twitter:image:src',
        content: 'https://lubumas.com/img/space3_facebook.png',
      },
      // Google / Schema.org markup:
      { itemprop: 'name', content: 'Lubumas | Plataforma de eCommerce' },
      {
        itemprop: 'description',
        content:
          'Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio',
      },
      {
        itemprop: 'image',
        content: 'https://lubumas.com/img/space3_facebook.png',
      },
    ],
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';

.not_visible_meta {
  visibility: hidden;
  height: 0;
  position: absolute;
}

.hero {
  //background: $bg-hero;
  background: url('../assets/img/bn_purple_3x.png') no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  position: relative;
  align-items: center;
  // justify-content: center;
  flex-direction: column;
  overflow: hidden;
  @media #{$large-up} {
    flex-direction: row;
    min-height: calc(90vh - 80px);
    justify-content: space-between;
    justify-content: none;
  }
  &::after {
    content: '';
    opacity: 0.04;
    position: absolute;
    bottom: -107px;
    height: 80vh;
    width: 173%;
    background: url('../assets/img/17947.svg') no-repeat;
    background-position: center;
    background-size: 67%;
    //transform: rotate(270deg);
  }
  .copy {
    position: relative;
    z-index: 1;
    width: 90%;
    padding: 50px 10px 30px;
    text-align: left;
    @media #{$large-up} {
      padding: 50px 10px 70px;
      margin-left: 50px;
      width: 600px;
    }
    &.video {
      padding: 10px 0 0;
      margin-left: 0;
      //width: auto;
      width: 100%;
      //background: #000;
      @media #{$tablet-up} {
        background: transparent;
        padding: 0px 0 50px 0;
        width: 90%;
      }
      @media #{$large-up} {
        width: 50%;
        //width: auto;
        padding: 50px 10px 70px;
        margin-right: 50px;
      }
    }
    .responsive-embed {
      padding: 10px;
      .v-image.hero__img {
        border-radius: 4px;
        height: 300px;
        width: 100%;
        max-width: 100%;
        box-shadow: $shadow-3;
        @media #{$tablet-up} {
          height: 300px;
        }
        @media #{$large-up} {
          height: 450px;
        }
      }
    }
    h1 {
      font-family: 'Roboto Condensed', sans-serif;
      font-weight: 700;
      line-height: 1.1;
      margin-bottom: 10px;
      &.copy__title {
        color: $text-site-primary; //$color-text;
        font-size: 3rem;
      }
    }
    p.copy__desc {
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      font-size: 1.3rem;
      color: $secondary-color; //$color-text;
    }
    .copy__btn {
      a {
        background: $color-primary-light;
        color: $secondary-color;
      }

      button {
        color: $bg-color-500;
        font-weight: bold;
        //@include pry-btn($primary-site-color, $text-site-white, 1rem, 150px);
        //height: 52px;
        &:hover {
          //box-shadow: $shadow-2;
        }
        span.icone {
          padding-left: 10px;
        }
      }
    }
  }
}
.bna_site {
  display: flex;
  flex-direction: row;
  //height: 70px;

  .bg_site_forme {
    position: absolute;
    z-index: 0;
    opacity: 0.06;
    height: 900px;
    width: 100%;
    max-width: 100%;
    background: url('../assets/img/mural_office_d.jpg') no-repeat;
    background-position: center;
    background-size: cover;
    @media #{$tablet-up} {
      background-size: contain;
    }
  }
  .bna__ctn-img {
    img {
      width: 100%;
      height: 160px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
.ctn__box {
  display: flex;
  .ctn__col {
    flex-basis: 33%;
  }
}
.st_sone {
  //margin-bottom: 30px;
  padding: 70px 0 60px;
  &.ini {
    //padding-top: 70px;
    padding-bottom: 50px;
  }
  &.fin {
    padding-bottom: 50px;
  }
  &.order {
    .order-col {
      &:nth-child(1) {
        order: 2;
        @media #{$large-up} {
          order: 1;
        }
      }
      &:nth-child(2) {
        order: 1;
        @media #{$large-up} {
          order: 2;
        }
      }
    }
  }
  .copy__imgsone {
    padding: 10px;
    @media #{$tablet-up} {
      padding: 5px;
    }
    .v-responsive.v-image .v-image__image {
      background-size: cover !important;
    }
    .v-image.img-home {
      border-radius: 4px;
      height: 300px !important;
      width: 100%;
      max-width: 100%;
      box-shadow: $shadow-2;
      @media #{$tablet-portrait} {
        width: 100%;
      }
      @media #{$large-up} {
        width: calc(100% - 10%);
      }
    }
    // .img-home {
    //   max-width: 100%;
    //   height: 300px;
    // }
  }
  .copy__sone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    .center__sone {
      padding: 20px 33px;
      .text-btn {
        color: #8600bc;
      }
    }

    p.title__sone {
      font-family: 'Roboto Condensed', sans-serif;
      font-weight: 700;
      font-size: 2.25rem;
    }
    p.desc__sone {
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      font-size: 1.3rem;
      color: #6b7177;
    }
    button {
      font-family: 'Roboto', sans-serif;
      @include link-btn(#028090, 0.8rem);
      font-weight: bold;
    }
  }
  .st__testimonial {
    display: flex;
    flex-direction: column;
    //height: 400px;
    @media #{$large-up} {
      flex-direction: row;
    }
    .box__img {
      flex-basis: 50%;
    }
    .box__copy {
      padding: 20px;
      flex-basis: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: #3600fb;

      p {
        padding: 0 20px;
        text-align: center;
        font-size: 2rem;
        font-family: 'Roboto Condensed', sans-serif;
        color: $color-text-primary;

        &.title__st {
          font-family: 'Roboto', sans-serif;
          font-weight: 700;
          font-size: 2rem;
          letter-spacing: -0.8px;
          color: $text-site-primary;
        }
        &.sub__st {
          color: $secondary-color;
          font-size: 1.5rem;
          padding-top: 40px;
        }
      }
    }
  }
}
</style>
